import React from 'react';
import ExternalLayout from '../layouts/externallayout';

const Unauthorized = ({ pageTitle = 'Unauthorized' }) => {
  return (
    <ExternalLayout pageTitle={pageTitle}>
        <div className="flex flex-col items-center justify-center h-screen">
            <h1 className="text-4xl font-bold">Unauthorized</h1>
            <p className="text-xl">You are not authorized to view this page</p>
        </div>
    </ExternalLayout>
  );
}

export default Unauthorized;
